@if (selected() || this.mode() === 'Create') {
  <app-dialog>
    @if (shareWithFriendsDisplay()) {
      <h2 title>My Friends</h2>
    }

    @if (isPreview()) {
      <h2 title> Story preview </h2>
    } @else if (!shareWithFriendsDisplay()){
      <h2 title>{{ mode() }} story</h2>
    }

    <form [formGroup]="form()">
      <div formArrayName="facets">
        <div *ngFor="let alias of facets()?.controls; let i=index" class="last:mb-0 mb-20">
          <div [formGroupName]="i">
            @if (isSelectFacets()) {

              <app-inline-dialog-title>Select facets</app-inline-dialog-title>
              <div class="mb-4">Please select {{ selectedFacetTypeName() }} Facet</div>

              <app-facet-grid-compact-container [facets]="facetModels()" (toggle)="toogleFacetModel($event)"
                                                [isCheckbox]="true"
                                                [checkedFacets]="selectedFacetModels()"></app-facet-grid-compact-container>

            } @else if (isPreview()) {
              <app-story-preview
                (shareWithFriendsScreen)="showShareWithFriendsScreen($event)"
                [isPreviewMode]="isPreview()"
                [audioUrl]="formArray().at(0).value?.audio"
                [story]="this.getSubmitPayload(formArray().at(0).value)"
                [imageUrls]="previewUrls()"
              >
              </app-story-preview>

            } @else if (shareWithFriendsDisplay()) {
              <app-share-story
                [acl]="storyAcl()"
                (shareWith)="updateAcl($event)"
              ></app-share-story>
            } @else {
              <app-form-grid>
                <div>
                  <app-input>
                    <input type="text" formControlName="title" placeholder="Story title">
                  </app-input>

                  <app-datepicker
                    [validate]="validateDatePicker()"
                    (dateChange)="onDateChange($event)"
                    [dateData]="dateData"
                    [userYears]="userYears()"
                  ></app-datepicker>

                  <app-voice-recording
                    class="mb-3 block"
                    formControlName="audio"
                    (stateChanged)="setAudioState($event)"
                    [audioUrl]="audioUrl()"
                    (recorded)="onAudioRecorded($event)"
                    (removeAudio)='onRemoveAudio($event)'
                    (transcriptChange)="onTranscriptChange($event)">

                  </app-voice-recording>

                  @if (formArray().at(0).get('audio')?.value && !isUploaded() && isNewAudioRecorded()) {
                    <div class="convert-button" (click)="convertVoiceToText()"> Convert to text</div>
                  }

                  <app-file-upload class="h-[130px] file-upload-container" formControlName="imageFile" [dragDrop]="true"
                                   [showPreview]="false"
                                   mode="multiple"
                                   (previewUrls)="setPreviewUrl($event)"></app-file-upload>
                </div>
                <div>

                  <div class="textarea-container">
                  <textarea [maxlength]="maxLengthTextarea" class="textarea story-description"
                            formControlName="content" placeholder="Your story..."
                            (input)="updateDescription($event)"></textarea>
                    <div class="char-counter">
                      {{ textContent.length }}/{{ maxLengthTextarea }}
                    </div>
                  </div>

                </div>
              </app-form-grid>

              <app-file-upload-preview class="mb-8 mt-4" [previewUrls]="previewUrls()"
                                       (remove)="onRemoveImage($event)"></app-file-upload-preview>

              @if (selectedFacetModels().length) {
                <p class="font-bold text-base mb-4 mt-6">What your story was about:</p>

                <app-facet-grid-compact-container [facets]="selectedFacetModels()" (toggle)="next()"
                                                  [isDeleteIcon]="true"
                                                  [isChevronIcon]="true"
                                                  (delete)="deleteFacetModel()">
                </app-facet-grid-compact-container>

              } @else {

                <p class="font-bold text-base mb-6 mt-6">Choose all the facets this story incorporates</p>

                <app-facet-selection formControlName="units" class="mb-7"
                                     [defaultSelectedFacet]="defaultSelectedFacet()"
                                     (selectedFacetChanged)="onSelectedFacetChanged($event)" facetType="userNoChapter"
                                     [withDescription]="true"></app-facet-selection>
              }
            }
          </div>
        </div>
      </div>
    </form>

    <div class="buttons" footer>
      @if (!shareWithFriendsDisplay()) {
        <div class="flex">
          <button appButton type="button" (click)="onSubmit()" class="min-w-[200px]"
                  [disabled]="!selectedFacetType()"> {{
              submitButtonText()
            }}
          </button>

          @if (!isSelectFacets() && !isPreview() && this.mode() === 'Create') {

            <button appTextButton type="button" class="min-w-[200px] ml-4" color="blue"
                    [disabled]="!selectedFacetType()"
                    (click)="onSaveDraft()">Save
              story to draft
            </button>

          }

        </div>
      }

      @if ((isSelectFacets() || isPreview()) && !shareWithFriendsDisplay()) {
        <button appTextButton type="button" class="back-button" color="blue" (click)="back()">Back</button>
      }

      @if (shareWithFriendsDisplay()) {
        <button appTextButton type="button" class="back-button share-screen" color="blue" (click)="backToPreview()">Back</button>
      }


    </div>
  </app-dialog>
}
